import {NgModule} from '@angular/core';
import {DatePipe} from '@angular/common';
import {DateMatchPipe} from './date-match.pipe';

@NgModule({
  declarations: [DateMatchPipe],
  exports: [DateMatchPipe],
  providers: [DatePipe],
})
export class DateMatchModule {}
